import React, { useRef, useEffect, useCallback, useState} from 'react';
import {lstorage} from 'utils/lstorage.js';
import ipfs from 'decentralized/Ipfs.js';
import {getWallpapers, newWallpaper} from 'decentralized/settings/appearance.js';
import {useScroll} from 'components/selector2/useScroll.js';
import {
    setWallpaper,
    setAnimateWallpaper,
} from 'actions/index.js';
import ImageHandler from 'components/explore/lists/ImageHandler.js';
import {connect} from 'react-redux';

const Appearance = (props) => { 
    let ref = useRef(undefined);
    let [imageHash, setImageHash] = useState(props.wallpaper);
    let [wallpapers, setWallpapers] = useState(undefined);

    let {size} = useScroll(ref, 9, true);

    useEffect(() => {
        if (imageHash)  {
            lstorage.setItem("wallpaper", imageHash);
            if (wallpapers && !wallpapers.map(x => x.wallpaper).includes(imageHash)) {
                newWallpaper(imageHash);
            }
            props.setWallpaper(imageHash);
        }
    }, [imageHash, wallpapers]);

    useEffect(() => {
        getWallpapers().then(setWallpapers);
    }, [setWallpapers]);

    let _wallpapers = wallpapers || [];
    return (
        <div className="appearance">
          <div className="wallpaper-header">Choose a wallpaper</div>
          <div className="wallpaper-toolbar">
            <div
              onClick={() => {
                  let animate = !props.animateWallpaper;
                  lstorage.setItem("animateWallpaper", animate);
                  props.setAnimateWallpaper(animate);
              }}
              className={props.animateWallpaper ?  "animate-btn selected" : "animate-btn"}>
              Animate
            </div>
            <div
              onClick={() => {
                  lstorage.removeItem("wallpaper");
                  props.setWallpaper(undefined);
              }}
              className={!props.wallpaper ?  "wall animate-btn selected" : "wall animate-btn"}>
              No Wallpaper
            </div>
          </div>
          <ImageHandler placeholder="Drag new wallpaper here" imageHash={imageHash} setImageHash={setImageHash}/>
          <div ref={ref} className="gallery">
            {_wallpapers.slice(0, size).map(
                ({wallpaper, thumbnail}) =>
                    <img
                      key={wallpaper}
                      onClick={() => setImageHash(wallpaper)}
                      src={ipfs.getHashUrl(thumbnail)}
                      className="wallpaper-choice"/>)}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      wallpaper: state.sequencer.wallpaper,
      animateWallpaper: state.sequencer.animateWallpaper
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setWallpaper: w => dispatch(setWallpaper(w)),
      setAnimateWallpaper: w => dispatch(setAnimateWallpaper(w))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Appearance);
